export interface ICadParam {
    idName: string;
    label: string;
    id?: number;
    defaultValue?: any;
    property?: string; // Nome da propriedade na classe CustomConfig
}